import { Directive, HostListener } from '@angular/core';

/**
 * Directive appliquée automatiquement à tous les input[type=number].
 * Bloque la saisie des caractères négatif (-), positif (+) et exponentiel (e/E).
 */
@Directive({
  selector: 'input[type=number]'
})
export class NumericInputDirective {

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    console.log("event.key", event.key);

    if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E') {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const pastedText = event.clipboardData.getData('text');
    if (/[-+eE]/.test(pastedText)) {
      event.preventDefault();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/directives/numeric-input.directive.ts